/**
 * RAM — UtmaSuccessor action.
 *
 * Placeholder — final spec pending Collette clarification.
 * Per procedures digest §RAM: "UTMA successor: pending Collette".
 */
import { Banner, Button, Pill } from '@/components/primitives';
import type { RamTarget } from '../types';

export interface UtmaSuccessorProps {
  target: RamTarget;
  onDone: () => void;
  onCancel: () => void;
}

export default function UtmaSuccessor({
  target,
  onCancel,
}: UtmaSuccessorProps): JSX.Element {
  return (
    <div className="ram-wizard">
      <div className="ram-wizard__header">
        <h2 className="ram-wizard__title">UTMA successor</h2>
        <Pill variant="warn">Pending clarification</Pill>
      </div>

      <Banner tone="warn">
        Successor-custodian designation rules are still being reviewed by
        Collette. When the age-of-majority + successor-custodian rules are
        signed off, this wizard will capture the successor's CIF and produce
        the UTMA designation form.
      </Banner>

      <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>
        CIF <code>{target.cifId}</code>
      </div>

      <div className="ram-wizard__actions">
        <Button variant="ghost" onClick={onCancel}>
          Back to actions
        </Button>
      </div>
    </div>
  );
}
